import axios, { addInterceptors } from './interceptor-axios';
import config from '~/config';
import { isDevMode } from '~/utils/mainHelpers/isDevMode';

class DesignService {
  constructor(token) {
    const headers = {};
    if (token) {
      headers.Authorization = token;
    }
    this.axios = axios.create({
      baseURL: config.apiUserURL,
      headers,
    });
    addInterceptors(this.axios);
  }

  listDesigns = ({ page, userId }) => {
    const request = {
      method: 'GET',
      url: '/designs',
      params: {
        page,
        max_results: 20,
        user_id: userId,
      },
    };
    return this.axios(request);
  };

  updateUserMaterialUsage = ({ userID, materialID, service }) => {
    if (materialID && service) {
      try {
        const request = {
          method: 'POST',
          url: '/materials',
          data: {
            userID,
            materialID,
            service,
            userAgent: window.navigator.userAgent,
          },
        };
        return this.axios(request);
      } catch (error) {
        console.log('updateUserMaterialUsage', error);
      }
    }
  };

  listAssets = ({ page, userId }) => {
    console.log('--- listAssets designService ---');
    console.log(userId);
    const request = {
      method: 'GET',
      url: '/assets',
      params: {
        page,
        max_results: 20,
        user_id: userId,
      },
    };
    return this.axios(request);
  };

  getDesignDetail = (id) => {
    const request = {
      method: 'GET',
      url: '/designs/detail',
      params: {
        id,
      },
    };
    return this.axios(request);
  };

  downloadAsset = (params) => {
    const request = {
      method: 'POST',
      url: '/assets/download',
      data: params,
    };
    return this.axios(request);
  };

  insertDbOfDesign = ({
    title,
    dataURL,
    thumbnailURL,
    previewURL,
    width,
    height,
    fontIDs,
    userId,
    templateId,
    numberPages,
    data,
    serviceType,
    dataId,
  }) =>
    this.axios({
      method: 'POST',
      url: '/designs/new',
      data: {
        title,
        data_url: dataURL,
        thumbnail_url: thumbnailURL,
        preview_url: previewURL,
        width,
        height,
        fontIDs,
        user_id: userId,
        template_id: templateId,
        num_pages: numberPages,
        user_agent: window.navigator.userAgent,
        data,
        service_type: serviceType,
        data_id: dataId,
      },
    });

  getUrlOfItem = (id) => {
    const request = {
      method: 'POST',
      url: '/designs/download',
      data: {
        id,
      },
    };
    return this.axios(request);
  };

  getDownloadLinksForDataPDF = (id) => {
    const request = {
      method: 'POST',
      url: '/designs/download-data-pdf',
      data: {
        id,
      },
    };
    return this.axios(request);
  };

  updateDesign = ({
    id,
    title,
    dataURL,
    width,
    height,
    fontIDs,
    userId,
    templateId,
    numberPages,
    data,
    serviceType,
    dataId,
  }) =>
    this.axios({
      method: 'PUT',
      url: '/designs/new',
      data: {
        id,
        title,
        data_url: dataURL,
        width,
        height,
        fontIDs,
        user_id: userId,
        template_id: templateId,
        num_pages: numberPages,
        user_agent: window.navigator.userAgent,
        data,
        service_type: serviceType,
        data_id: dataId,
      },
    });

  backupDesign = ({ designId, backUpPages }) => {
    return this.axios({
      method: 'POST',
      url: '/designs/backup',
      data: {
        designId,
        backUpPages,
      },
    })
      .then(() => {})
      .catch(() => {});
  };

  updateUserDevice = ({ id, isSaveOnMobile }) =>
    this.axios({
      method: 'PUT',
      url: '/user/device',
      data: {
        id,
        isSaveOnMobile,
      },
    });

  updateDesignTitle = ({ id, title, userId, lang, role }) => {
    const request = {
      method: 'PUT',
      url: '/designs',
      data: {
        id,
        title,
        user_id: userId,
        lang,
        role,
      },
    };
    return this.axios(request);
  };

  deleteAsset = (id) => {
    const request = {
      method: 'DELETE',
      url: '/assets',
      data: {
        id,
      },
    };
    return this.axios(request);
  };

  linkWithDesignAC = ({ id, dataID }) => {
    const request = {
      method: 'POST',
      url: '/designs/link-designac',
      data: {
        id,
        data_id: dataID,
      },
    };
    return this.axios(request);
  };

  deleteDesign = (id, userId) => {
    const request = {
      method: 'DELETE',
      url: '/designs',
      data: {
        id,
        user_id: userId,
      },
    };
    return this.axios(request);
  };

  enableShareDesign = ({ id, mode }) => {
    const request = {
      method: 'POST',
      url: '/designs/share/enable',
      data: {
        id,
        mode,
      },
    };
    return this.axios(request);
  };

  disableShareDesign = ({ id, mode }) => {
    const request = {
      method: 'POST',
      url: '/designs/share/disable',
      data: {
        id,
        mode,
      },
    };
    return this.axios(request);
  };

  getDetailSharedDesign = ({ shareKey, userId }) => {
    const request = {
      method: 'GET',
      url: '/designs/share/detail',
      params: {
        shareKey,
        user_id: userId,
      },
    };
    return this.axios(request);
  };

  downloadSharedDesign = ({ shareKey, userId }) => {
    const request = {
      method: 'GET',
      url: '/designs/share/download',
      params: {
        shareKey,
        user_id: userId,
      },
    };
    return this.axios(request);
  };

  copyDesign = ({ id, userId }) => {
    const request = {
      method: 'POST',
      url: '/designs/copy',
      data: {
        id,
        user_id: userId,
      },
    };
    return this.axios(request);
  };

  addCollabUser = ({ id, userId, email }) => {
    const request = {
      method: 'POST',
      url: '/designs/collaboration',
      data: {
        id,
        user_id: userId,
        email,
      },
    };
    return this.axios(request);
  };

  removeCollabUser = ({ id, userId, email }) => {
    const request = {
      method: 'DELETE',
      url: '/designs/collaboration',
      data: {
        id,
        user_id: userId,
        email,
      },
    };
    return this.axios(request);
  };

  getListCollabUsers = ({ id, userId }) => {
    const request = {
      method: 'GET',
      url: '/designs/collaboration',
      params: {
        id,
        user_id: userId,
      },
    };
    return this.axios(request);
  };

  getListSharedDesignsByUser = ({ userId, page, max_results }) => {
    const request = {
      method: 'GET',
      url: '/designs/shared',
      params: {
        page,
        max_results,
        user_id: userId,
      },
    };
    return this.axios(request);
  };

  recordDownloadDesign = ({ id }) => {
    const request = {
      method: 'POST',
      url: '/designs/record-download',
      data: {
        id,
      },
    };
    return this.axios(request);
  };

  feedbackDesign = (data) => {
    const request = {
      method: 'POST',
      url: '/feedback/design',
      data,
    };
    return this.axios(request);
  };

  updatefeedbackDesign = (data) => {
    const request = {
      method: 'PUT',
      url: '/feedback/update',
      data,
    };
    return this.axios(request);
  };

  trackingActionDesign = (data) => {
    const request = {
      method: 'POST',
      url: '/tracking/action',
      data,
    };
    return this.axios(request);
  };

  triggerThumbnailGeneration = (data) => {
    if (data?.id) {
      const request = {
        method: 'POST',
        url: '/designs/generate-thumbnail',
        data,
      };
      return this.axios(request);
    }
  };
}

export default new DesignService();
